// vivo 锁屏
export default {
  // 印尼语域名
  "id-v-ls.comfortweather.com": {
    ad1: [
      {
        // type: "ads",
        // slot: 3922785402,
        // style: { display: "inline-block", width: "320px", height: "100px" },

        type: "adx",
        id: "div-gpt-ad-1759465473098-0",
        slot: "/23161678951/id_v_ls_comfortweather_20251003_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9760659739,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759477534123-0",
        slot: "/23161678951/id_v_ls_comfortweather_20251003_320x100_under",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/id_v_ls_comfortweather_20251003_320x100_under",
        position: "position-01",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1778653173517-0",
        slot: "/23161678951/id_v_ls_comfortweather_20260512_320x100_center",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 9494907791,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465504002-0",
        slot: "/23161678951/id_v_ls_comfortweather_20251003_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 4160387309,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465530212-0",
        slot: "/23161678951/id_v_ls_comfortweather_20251003_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 9767464449,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465563190-0",
        slot: "/23161678951/id_v_ls_comfortweather_20251003_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 2847305636,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465593338-0",
        slot: "/23161678951/id_v_ls_comfortweather_20251003_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 越南语域名
  "vi-v-ls.comfortweather.com": {
    ad1: [
      {
        // type: "ads",
        // slot: 6594978951,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465791131-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 6148717785,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759477617946-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x100_under",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x100_under",
        position: "position-01",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1778653273431-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20260512_320x100_center",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 8179523367,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465820208-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 5553360028,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465850682-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 2655733949,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465879818-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 8151130441,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465907646-0",
        slot: "/23161678951/vi_v_ls_comfortweather_20251003_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 泰语域名
  "th-v-ls.comfortweather.com": {
    ad1: [
      {
        // type: "ads",
        // slot: 7879667709,
        // style: { display: "inline-block", width: "320px", height: "100px" },

        type: "adx",
        id: "div-gpt-ad-1759465629569-0",
        slot: "/23161678951/th_v_ls_comfortweather_20251003_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 9569088042,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759477577379-0",
        slot: "/23161678951/th_v_ls_comfortweather_20251003_320x100_under",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/th_v_ls_comfortweather_20251003_320x100_under",
        position: "position-01",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1778653230511-0",
        slot: "/23161678951/th_v_ls_comfortweather_20260512_320x100_center",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 3390231117,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465659444-0",
        slot: "/23161678951/th_v_ls_comfortweather_20251003_320x250_1",
        rect: [320, 250],
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 1536295211,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465690513-0",
        slot: "/23161678951/th_v_ls_comfortweather_20251003_320x250_2",
        rect: [320, 250],
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 4324038831,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465722139-0",
        slot: "/23161678951/th_v_ls_comfortweather_20251003_320x250_3",
        rect: [320, 250],
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 8048092625,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465753976-0",
        slot: "/23161678951/th_v_ls_comfortweather_20251003_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 印地语域名
  "hi-v-ls.comfortweather.com": {
    ad1: [
      {
        // type: "ads",
        // slot: 8450986107,
        // style: { display: "inline-block", width: "320px", height: "100px" },

        type: "adx",
        id: "div-gpt-ad-1759465292736-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20251003_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 2704071453,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759477491532-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20251003_320x100_under",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-01",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1778653129525-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20260512_320x100_center",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 4108847615,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465331170-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20251003_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 5085983409,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465360672-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20251003_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 2459820066,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465393075-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20251003_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 1146738395,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465438347-0",
        slot: "/23161678951/hi_v_ls_comfortweather_20251003_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
  // 英语域名
  "en-v-ls.comfortweather.com": {
    ad1: [
      {
        // type: "ads",
        // slot: 5798744940,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759473378908-0",
        slot: "/23161678951/en_v_ls_comfortweather_20251003_320x100",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        // type: "ads",
        // slot: 4056643581,
        // style: {
        //   display: "inline-block",
        //   width: "320px",
        //   height: "100px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759477439042-0",
        slot: "/23161678951/en_v_ls_comfortweather_20251003_320x100_under",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },

        // type: "anchor",
        // slot: "/23161678951/en_v_ls_comfortweather_20251003_320x100_under",
        position: "position-01",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1778653019040-0",
        slot: "/23161678951/en_v_ls_comfortweather_20260512_320x100_center",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
    ],
    ad2: [
      {
        // type: "ads",
        // slot: 6394980043,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465167356-0",
        slot: "/23161678951/en_v_ls_comfortweather_20251003_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        // type: "ads",
        // slot: 3384334599,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465196226-0",
        slot: "/23161678951/en_v_ls_comfortweather_20251003_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        // type: "ads",
        // slot: 3168712177,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465225919-0",
        slot: "/23161678951/en_v_ls_comfortweather_20251003_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        // type: "ads",
        // slot: 6916385490,
        // style: {
        //   display: "inline-block",
        //   width: "300px",
        //   height: "250px",
        // },

        type: "adx",
        id: "div-gpt-ad-1759465253119-0",
        slot: "/23161678951/en_v_ls_comfortweather_20251003_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
};
